module.exports = __webpack_public_path__ + "static/brand13-14b386b87a434f2f4c9aba71fcdd077e.png";